import type { FaireProductEntity } from "../../entity_types/product";

export const p_6oq110ae: FaireProductEntity = {
  token: "p_6oq110ae",
  type: "product",
  name: "Aloha 'Aina \u2013 Plumeria Nectar Pure Bar Soap",
  brandName: "Maui Soap Co.",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b42735932dda63847ed5c09ed6b303c95e6c47b03c7ff926543203f5bc54b292/1563995312.jpg",
  priceDollars: 5.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ee1378d94a9220e554cca56ac44acb6f8e5ddfdc181707cca100cc1e982a605f.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
